import React, { useEffect } from "react";

const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="legal-content">
          <h1 className="legal-title">Terms of Use</h1>
          <p className="legal-effective">Effective Date: June 1, 2025</p>
          <p className="legal-effective">Last Reviewed: August 20, 2026</p>

          <p className="legal-intro">
            Welcome to Avenir AI. By accessing or using our website, platform, or
            services, you agree to be bound by the following terms. Please read
            them carefully.
          </p>

          <div className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By using Avenir AI, you agree to comply with and be legally bound by
              these Terms of Use, our Privacy Policy, and all applicable laws and
              regulations. If you do not agree with any part of these terms, you may
              not access or use our services.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Use of Services</h2>
            <p>
              Avenir AI provides software tools for analyzing employee benefits,
              wellness data, and productivity insights. You may only use these
              services for lawful and authorized purposes in accordance with your
              company's agreement with Avenir AI.
            </p>
          </div>

          <div className="legal-section">
            <h2>3. User Accounts and Access</h2>
            <p>
              You are responsible for maintaining the confidentiality of your login
              credentials and for any activity under your account. You agree to
              notify us immediately if you suspect any unauthorized access.
            </p>
          </div>

          <div className="legal-section">
            <h2>4. Intellectual Property</h2>
            <p>
              All content, code, and services provided by Avenir AI are the
              intellectual property of Avenir AI and protected by copyright,
              trademark, and other laws. You may not copy, modify, distribute, or
              reverse-engineer any part of our platform without written permission.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. Data and Privacy</h2>
            <p>
              Your use of our services may involve the processing of protected
              health information (PHI) or personal data. You agree to comply with
              applicable privacy laws (e.g., HIPAA, CCPA) and our Privacy Policy,
              which outlines how data is collected, used, and safeguarded.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Termination</h2>
            <p>
              Avenir AI reserves the right to suspend or terminate access to our
              services at any time, with or without cause, and without liability.
              Your obligations related to intellectual property and data handling
              will survive termination.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Avenir AI shall not be liable
              for any indirect, incidental, or consequential damages resulting from
              your use of our services. Our total liability under these terms is
              limited to the amount paid by your organization, if any, in the last
              12 months.
            </p>
          </div>

          <div className="legal-section">
            <h2>8. Modifications</h2>
            <p>
              We may revise these Terms of Use from time to time. Updates will be
              posted on this page with a new effective date. Continued use of our
              services after changes constitutes your acceptance of the revised
              terms.
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Contact</h2>
            <p>
              If you have questions about these Terms of Use, please contact us at{" "}
              <a href="mailto:info@avenir.com.ai">info@avenir.com.ai</a>.
            </p>
          </div>

          <div className="legal-section appendix">
            <h2>Appendix – Subprocessors</h2>
            <p>
              To provide services, Avenir AI engages third-party subprocessors who
              may process personal data on our behalf. Our current subprocessors
              include:
            </p>
            <ul className="subprocessor-list">
              <li>
                <strong>Google Cloud Platform</strong> – cloud hosting and database infrastructure
              </li>
              <li>
                <strong>Firebase</strong> – authentication and real-time database
              </li>
              <li>
                <strong>OpenAI</strong> – AI response generation
              </li>
              <li>
                <strong>Pinecone</strong> – semantic search and vector database
              </li>
              <li>
                <strong>Drata</strong> – compliance automation services
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="legal-cta">
        <h2>Need Help?</h2>
        <p>
          Reach out to our team with any questions about compliance, usage, or
          account access.
        </p>
        <a href="mailto:info@avenir.com.ai" className="legal-cta-button">
          Email Legal Team
        </a>
      </section>
    </div>
  );
};

export default TermsOfUse;